import moment from "moment";

export const formatChartData = (data, dataFor) => {
  let labels = [],
    datasets = [];

  const config = {
    backgroundColor: "#22CECE",
    borderWidth: 1,
  };

  const config2 = {
    backgroundColor: "#FF3D67",
    borderWidth: 1,
  };

  switch (dataFor) {
    case "country": {
      labels = data.country.map((item) => item.name);
      datasets = [
        {
          label: `${"Screen Page views"}`,
          data: data.country.map((item) => item.screenPageViews),
          ...config,
        },
        {
          label: `${"Sessions"}`,
          data: data.country.map((item) => item.sessions),
          ...config2,
        },
      ];
      break;
    }

    case "deviceCategory": {
      labels = data.deviceCategory.map((item) => item.name);
      datasets = [
        {
          label: `${"Screen Page views"}`,
          data: data.deviceCategory.map((item) => item.screenPageViews),
          ...config,
        },
        {
          label: `${"Sessions"}`,
          data: data.deviceCategory.map((item) => item.sessions),
          ...config2,
        },
      ];
      break;
    }

    case "date": {
      labels = data.date.map((item) => moment(item.name).format("YYYY-MM-DD"));
      datasets = [
        {
          label: `${"Screen Page views"}`,
          data: data.date.map((item) => item.screenPageViews),
          ...config,
        },
        {
          label: `${"Sessions"}`,
          data: data.date.map((item) => item.sessions),
          ...config2,
        },
      ];
      break;
    }

    default: {
      labels = data.country.map((item) => item.name);
      datasets = [
        {
          label: `${"Screen Page views"}`,
          data: data.country.map((item) => item.screenPageViews),
          ...config,
        },
        {
          label: `${"Sessions"}`,
          data: data.country.map((item) => item.sessions),
          ...config2,
        },
      ];
      break;
    }
  }

  return {
    labels,
    datasets,
  };
};
